import {useEffect, useState} from "react";

const usePagination = (data, initialPageSize = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [paginatedData, setPaginatedData] = useState([]);

  useEffect(() => {
    const endIndex = currentPage * pageSize;
    const startIndex = endIndex - pageSize;
    if (data?.length <= pageSize) {
      setPaginatedData(data)
    } else {
      const paginated = data?.slice(startIndex, endIndex)?? [];
      setPaginatedData(paginated);
    }
  }, [data, currentPage, pageSize]);


  return {currentPage, setCurrentPage, 
  paginatedData, setPaginatedData, 
  pageSize, setPageSize, 
  totalItems: data?.length?? 0}
};

export default usePagination;

//   処置状況 



